<template>
  <div>
    <!-- 确保有router-view -->
    <router-view></router-view>
    
    <!-- 添加测试链接 -->
    <!-- <router-link to="/privacy">测试隐私政策链接</router-link> -->
  </div>
</template>